import { Store } from '@datorama/akita';

class AbstractFacade {
  constructor(readonly store: Store) {}

  async doRequest(operation: () => Promise<any>) {
    this.store.setLoading(true);

    const res = await operation();

    this.store.setLoading(false);

    return res;
  }
}

export default AbstractFacade;
